import { render, staticRenderFns } from "./HeatmapInsurance.vue?vue&type=template&id=8800a818&scoped=true&"
import script from "./HeatmapInsurance.vue?vue&type=script&lang=js&"
export * from "./HeatmapInsurance.vue?vue&type=script&lang=js&"
import style0 from "./HeatmapInsurance.vue?vue&type=style&index=0&id=8800a818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8800a818",
  null
  
)

export default component.exports